import { render, staticRenderFns } from "./DispensingTableComponent.vue?vue&type=template&id=1ea46176&scoped=true"
import script from "./DispensingTableComponent.vue?vue&type=script&lang=js"
export * from "./DispensingTableComponent.vue?vue&type=script&lang=js"
import style0 from "./DispensingTableComponent.vue?vue&type=style&index=0&id=1ea46176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea46176",
  null
  
)

export default component.exports